import React from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
export function PricingSection() {
  return <section id="pricing" className="bg-[#F5F5F5] py-10 md:py-16 px-4 md:px-8" data-id="element-90">
      <div className="max-w-3xl mx-auto" data-id="element-91">
        <FadeIn data-id="element-92">
          <div className="bg-white rounded-3xl shadow-2xl p-5 md:p-10 text-center border-t-8 border-[#2D5A27]" data-id="element-93">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6" data-id="element-94">
              Llevate hoy todo el sistema + los 4 bonos de regalo.
            </h2>

            <div className="mb-4 md:mb-6" data-id="element-95">
              <p className="text-gray-500 text-lg line-through mb-2" data-id="element-96">
                Precio Original: $90.000 ARS
              </p>
              <div className="flex justify-center items-baseline gap-2" data-id="element-97">
                <span className="text-gray-600 text-xl font-bold" data-id="element-98">
                  SOLO HOY
                </span>
                <span className="text-4xl md:text-7xl font-black text-[#FF9F43] tracking-tight" data-id="element-99">
                  $19.999
                </span>
                <span className="text-gray-600 text-xl font-bold" data-id="element-100">ARS</span>
              </div>
            </div>

            <CTAButton className="w-full mb-6" href="https://pagos.indigo33.shop/cart/44005501993048:1" data-id="element-101">
              SÍ, QUIERO EL ACCESO INMEDIATO
            </CTAButton>

            <div className="flex flex-wrap justify-center items-center gap-6 text-gray-500" data-id="element-102">
              <div className="flex items-center gap-2" data-id="element-103">
                <AccountBalanceWalletIcon data-id="element-104" />
                <span className="font-medium" data-id="element-105">Mercado Pago</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-106">
                <CreditCardIcon data-id="element-107" />
                <span className="font-medium" data-id="element-108">Tarjetas de Crédito/Débito</span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}